// extracted by mini-css-extract-plugin
export default {"error_page":"style_error_page__4hDuX","intro_text":"style_intro_text__uSOpT"};